import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TagInput } from './tag-input';
import { InventoryService } from '@data/services/inventory.service';

@Component({

    selector: 'syn-inventory-tag-input',
    templateUrl: 'tag-input.html',
    styleUrls: ['tag-input.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InventoryTagInputComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => InventoryTagInputComponent), multi: true }
    ]
})
export class InventoryTagInputComponent extends TagInput {
    constructor(inventoryService: InventoryService) {
        super(inventoryService);
    }
}
